import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import type { Supplier } from "../models/Supplier";
import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";

interface UseTableDataProps {
	onDelete: (supplier: Supplier) => void;
}

export const useTableData = ({ onDelete }: UseTableDataProps) => {
	const columnDefs: ColDef<Supplier>[] = [
		{
			field: "Name",
			headerName: "Name",
			flex: 2,
			sortable: true,
			filter: true,
		},
		{
			field: "ShortName",
			headerName: "Short Name",
			flex: 0.9,
			sortable: true,
			filter: true,
		},
		{
			field: "Address1",
			headerName: "Address 1",
			flex: 1.9,
			sortable: true,
			filter: true,
		},
		{
			field: "City",
			headerName: "City",
			flex: 1,
			sortable: true,
			filter: true,
		},
		{
			field: "State",
			headerName: "State",
			flex: 1,
			sortable: true,
			filter: true,
		},
		{
			field: "Zip",
			headerName: "Zip",
			flex: 0.8,
			sortable: true,
			filter: true,
		},
		{
			field: "Country",
			headerName: "Country",
			flex: 1,
			sortable: true,
			filter: true,
		},
		{
			field: "Contact",
			headerName: "Contact Name 1",
			flex: 1.25,
			sortable: true,
			filter: true,
		},
		activeColumnDef<Supplier>(),
		{
			headerName: "",
			width: 60,
			minWidth: 60,
			maxWidth: 60,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			cellRenderer: (params: ICellRendererParams<Supplier>) => {
				if (!params.data) return null;
				return (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(params.data as Supplier);
								}}
								color="error"
								sx={{ p: 0.25 }}
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
